import type {
  Components,
  MaterialsAndCare as MaterialsAndCareSchema,
} from '@amplience/content-types/typings/c-materials-and-care';
import type { SlotContents } from '@amplience/content-types/typings/s-pdp-layout';
import type { CommercetoolsProductType, ProductMaterial } from '@storefront/lib-global/codegen/types';
import { getLocalizedValue } from '@storefront/lib-global/utils/transformers';
import { MaterialsAndCare } from './MaterialsAndCare/MaterialsAndCare';
import { MaterialsContent } from './MaterialsContent';
import { MaterialsTable } from './MaterialsTable';

type MaterialSectionProps = {
  materialsAndCareBlock: SlotContents['materialsAndCareBlock'];
  materials: ProductMaterial[];
  type: CommercetoolsProductType;
};

export function MaterialSection({ materialsAndCareBlock, materials, type }: MaterialSectionProps) {
  return (
    <MaterialsAndCare header={getLocalizedValue((materialsAndCareBlock as unknown as MaterialsAndCareSchema)?.heading)}>
      <MaterialsTable materials={materials} />
      <hr />
      <MaterialsContent
        components={(materialsAndCareBlock as unknown as MaterialsAndCareSchema)?.components as Components}
        type={type}
      />
    </MaterialsAndCare>
  );
}

export default MaterialSection;
